import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { CardModule } from 'app/shared/components/card/card.module';
import { IconicModule } from 'app/shared/components/iconic/iconic.module';
import { ListModule } from 'app/shared/components/list/list.module';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';
import { FilterTextModule } from '../filter-text/filter-text.module';
import { FloatingFilterComponent } from './floating-filter.component';

@NgModule({
  imports: [
    CommonModule,
    ListModule,
    CardModule,
    ButtonModule,
    IconicModule,
    TooltipModule,
    FilterTextModule,
  ],
  declarations: [FloatingFilterComponent],
  exports: [FloatingFilterComponent],
})
export class FloatingFilterModule {}
